"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgNamedVersionAdd(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm4.2773 15.9779a.6669.6669 0 0 1 -.8139-.4655l-3.4405-12.6673a.65421.65421 0 0 1 .463-.801l.007-.00182a.66651.66651 0 0 1 .8136.4645l3.439 12.6673a.6554.6554 0 0 1 -.46362.80259zm5.7227-7.9079v-1.071h3.704a3.98556 3.98556 0 0 0 .296-.267l-1.827-6.733a3.9458 3.9458 0 0 1 -2.0152 1.157 7.6452 7.6452 0 0 1 -1.9738.1814c-.648-.006-1.289-.047-1.936-.054a7.685 7.685 0 0 0 -1.9747.18 3.93784 3.93784 0 0 0 -2.0149 1.1576l1.829 6.731a3.93436 3.93436 0 0 1 2.0149-1.1563 7.80515 7.80515 0 0 1 1.9725-.1839c.645.007 1.282.048 1.926.057m.9992-.0688v3h-3v2h3v3h2v-3h3v-2h-3v-3z' })));
}
exports.default = SvgNamedVersionAdd;
